var map = {
	"./data/beststats": "f771",
	"./data/beststats.json": "f771",
	"./data/bookmakercomparison": "ab03",
	"./data/bookmakercomparison.json": "ab03",
	"./data/bookmakercountrylicenses": "5de3",
	"./data/bookmakercountrylicenses.json": "5de3",
	"./data/bookmakerlicenses": "bb66",
	"./data/bookmakerlicenses.json": "bb66",
	"./data/currency": "ccdd",
	"./data/currency.json": "ccdd",
	"./data/featuresacross": "48ab",
	"./data/featuresacross.json": "48ab",
	"./data/languagealternatives Germany": "fa6b",
	"./data/languagealternatives Germany.json": "fa6b",
	"./data/licensedcountry": "a7e7",
	"./data/licensedcountry.json": "a7e7",
	"./data/licenses": "757d",
	"./data/licenses.json": "757d",
	"./data/oddsanalysistypes": "eb65",
	"./data/oddsanalysistypes.json": "eb65",
	"./data/ogbetstats": "11e6",
	"./data/ogbetstats.json": "11e6",
	"./data/popularcompetitions": "2899",
	"./data/popularcompetitions.json": "2899",
	"./data/rugbyunion kitdetails": "7edf",
	"./data/rugbyunion kitdetails.json": "7edf",
	"./data/sitestats": "e90d",
	"./data/sitestats.json": "e90d",
	"./data/slider Germany": "29ed",
	"./data/slider Germany.json": "29ed",
	"./data/slider Ireland": "6b80",
	"./data/slider Ireland.json": "6b80",
	"./data/slider United Kingdom": "ee82",
	"./data/slider United Kingdom.json": "ee82",
	"./data/soccer kitdetails": "83a7",
	"./data/soccer kitdetails.json": "83a7",
	"./data/soccer kitdetails_old": "5aeb",
	"./data/soccer kitdetails_old.json": "5aeb",
	"./data/sportswithodds": "1a34",
	"./data/sportswithodds.json": "1a34",
	"./data/timezones": "9326",
	"./data/timezones.json": "9326",
	"./data/venue": "7a61",
	"./data/venue.json": "7a61",
	"./fonts/inter-v20-latin-300.woff2": "d3c2",
	"./fonts/inter-v20-latin-500.woff2": "59e9",
	"./fonts/inter-v20-latin-600.woff2": "f16b",
	"./fonts/inter-v20-latin-700.woff2": "0d5f",
	"./fonts/inter-v20-latin-regular.woff2": "d105",
	"./icons/Home.png": "ccbc",
	"./icons/all-icon.png": "438e",
	"./icons/all-inclusive.png": "46f2",
	"./icons/all-inclusive2.png": "06d9",
	"./icons/analytics-whi.png": "76ef",
	"./icons/beginners.png": "d1a5",
	"./icons/bet-whi.png": "7bec",
	"./icons/betcalc.png": "b98f",
	"./icons/betfinder.png": "569d",
	"./icons/bookmaker-whi.png": "105e",
	"./icons/bookmaker.png": "3d62",
	"./icons/browse.png": "1d07",
	"./icons/cashback.png": "e6cd",
	"./icons/clear.png": "8e9c",
	"./icons/download.png": "4651",
	"./icons/event-whi.png": "4051",
	"./icons/event.png": "a4ab",
	"./icons/freebies.png": "aeb5",
	"./icons/horses-mouth-small.png": "0728",
	"./icons/horses-mouth-whi.png": "8f45",
	"./icons/horses-mouth.png": "66d0",
	"./icons/intro.png": "8272",
	"./icons/knowledge-whi.png": "366d",
	"./icons/knowledge.png": "4159",
	"./icons/kyc.png": "f88d",
	"./icons/licensing.png": "24c3",
	"./icons/megafone.png": "d58d",
	"./icons/megafone2.png": "6c47",
	"./icons/old/all.png": "5735",
	"./icons/old/bets.png": "df85",
	"./icons/old/bonus.png": "8794",
	"./icons/old/bookmaker.png": "c31f",
	"./icons/old/cashback.png": "afc9",
	"./icons/old/extraplaces.png": "861a",
	"./icons/old/free.png": "72d7",
	"./icons/old/goododdsspot.png": "13b7",
	"./icons/old/horserelated.png": "f2ff",
	"./icons/old/odds.png": "44e8",
	"./icons/old/reports.png": "3416",
	"./icons/pete.png": "8626",
	"./icons/places.png": "2bff",
	"./icons/playersout.png": "6fea",
	"./icons/promo.png": "ec7e",
	"./icons/regular-promos.png": "797f",
	"./icons/save.png": "4b65",
	"./icons/sleep.png": "ef9c",
	"./icons/spot.png": "027a",
	"./images/18plus.png": "e68b",
	"./images/GambleAware Main.png": "791a",
	"./images/OddsGaloreLogoGrey.png": "f46f",
	"./images/OddsGalorelogo.png": "3bdf",
	"./images/btn_google_signin_light_normal_web.png": "f3b2",
	"./images/carousel/Football .webp": "a7d2",
	"./images/carousel/horseracing 2.webp": "ac8e",
	"./images/carousel/slide1.webp": "f016",
	"./images/carousel/slide2.webp": "ec5d",
	"./images/carousel/slide3.webp": "3ad0",
	"./images/carousel/slide4.webp": "c3dd",
	"./images/carousel/slidesmall.gif": "8a17",
	"./images/carousel/slidesmall.png": "168a",
	"./images/delete-26.png": "570b",
	"./images/download-26.png": "f987",
	"./images/fb_icon.png": "582f",
	"./images/flags/svg/Abkhazia.svg": "1133",
	"./images/flags/svg/Afghanistan.svg": "1ba1",
	"./images/flags/svg/Aland Islands.svg": "ca5e",
	"./images/flags/svg/Albania.svg": "3be0",
	"./images/flags/svg/Alderney.svg": "6a2f",
	"./images/flags/svg/Algeria.svg": "e701",
	"./images/flags/svg/American Samoa.svg": "d0c5",
	"./images/flags/svg/Andorra.svg": "0d15",
	"./images/flags/svg/Angola.svg": "bd3a",
	"./images/flags/svg/Anguilla.svg": "ea63",
	"./images/flags/svg/Antigua and Barbuda.svg": "3a36",
	"./images/flags/svg/Argentina.svg": "d70f",
	"./images/flags/svg/Armenia.svg": "2526",
	"./images/flags/svg/Aruba.svg": "204d",
	"./images/flags/svg/Australia.svg": "8400",
	"./images/flags/svg/Austria.svg": "4fb6",
	"./images/flags/svg/Azerbaijan.svg": "bcbb",
	"./images/flags/svg/Azores Islands.svg": "a020",
	"./images/flags/svg/Bahamas.svg": "cc6e",
	"./images/flags/svg/Bahrain.svg": "3bbe",
	"./images/flags/svg/Balearic Islands.svg": "3d4e",
	"./images/flags/svg/Bangladesh.svg": "5a08",
	"./images/flags/svg/Barbados.svg": "3cca",
	"./images/flags/svg/Basque Country.svg": "ab52",
	"./images/flags/svg/Belarus.svg": "1197",
	"./images/flags/svg/Belgium.svg": "adcf",
	"./images/flags/svg/Belize.svg": "d5c9",
	"./images/flags/svg/Benin.svg": "8a55",
	"./images/flags/svg/Bermuda.svg": "7aa0",
	"./images/flags/svg/Bhutan.svg": "5178",
	"./images/flags/svg/Bolivia.svg": "3d13",
	"./images/flags/svg/Bonaire.svg": "8f03",
	"./images/flags/svg/Bosnia and Herzegovina.svg": "9068",
	"./images/flags/svg/Botswana.svg": "8212",
	"./images/flags/svg/Brazil.svg": "ef13",
	"./images/flags/svg/British Columbia.svg": "abb3",
	"./images/flags/svg/British Indian OceanTerritory.svg": "da63",
	"./images/flags/svg/British Virgin Islands.svg": "7fcb",
	"./images/flags/svg/Brunei.svg": "e986",
	"./images/flags/svg/Bulgaria.svg": "ea70",
	"./images/flags/svg/Burkina Faso.svg": "b42a",
	"./images/flags/svg/Burundi.svg": "bdfb",
	"./images/flags/svg/Cambodia.svg": "0962",
	"./images/flags/svg/Cameroon.svg": "45e8",
	"./images/flags/svg/Canada.svg": "2eb4",
	"./images/flags/svg/Canary Islands.svg": "7176",
	"./images/flags/svg/Cape Verde.svg": "3dd0",
	"./images/flags/svg/Cayman Islands.svg": "7b65",
	"./images/flags/svg/Central African Republic.svg": "0a0b",
	"./images/flags/svg/Ceuta.svg": "d1b1",
	"./images/flags/svg/Chad.svg": "4780",
	"./images/flags/svg/Chile.svg": "0051",
	"./images/flags/svg/China.svg": "0951",
	"./images/flags/svg/Christmas Island.svg": "c54b",
	"./images/flags/svg/Cocos Island.svg": "a6f4",
	"./images/flags/svg/Colombia.svg": "3891",
	"./images/flags/svg/Comoros.svg": "22c0",
	"./images/flags/svg/Cook Islands.svg": "9284",
	"./images/flags/svg/Corsica.svg": "8180",
	"./images/flags/svg/Costa Rica.svg": "95ea",
	"./images/flags/svg/Croatia.svg": "1570",
	"./images/flags/svg/Cuba.svg": "c55f",
	"./images/flags/svg/Curacao.svg": "4d38",
	"./images/flags/svg/Cyprus.svg": "cd98",
	"./images/flags/svg/Czech Republic.svg": "5669",
	"./images/flags/svg/Democratic Republic of Congo.svg": "533a",
	"./images/flags/svg/Denmark.svg": "7df5",
	"./images/flags/svg/Djibouti.svg": "f749",
	"./images/flags/svg/Dominica.svg": "472b",
	"./images/flags/svg/Dominican Republic.svg": "220a",
	"./images/flags/svg/East Timor.svg": "1a5b",
	"./images/flags/svg/Ecuador.svg": "bd20",
	"./images/flags/svg/Egypt.svg": "5efc",
	"./images/flags/svg/El Salvador.svg": "4fc0",
	"./images/flags/svg/England.svg": "cac5",
	"./images/flags/svg/Equatorial Guinea.svg": "a606",
	"./images/flags/svg/Eritrea.svg": "9d50",
	"./images/flags/svg/Estonia.svg": "86dd",
	"./images/flags/svg/Eswatini.svg": "fee7",
	"./images/flags/svg/Ethiopia.svg": "74e2",
	"./images/flags/svg/Europe.svg": "b5a6",
	"./images/flags/svg/Falkland Islands.svg": "bb99",
	"./images/flags/svg/Faroe Islands.svg": "57fa",
	"./images/flags/svg/Fiji.svg": "a90b",
	"./images/flags/svg/Finland.svg": "cab8",
	"./images/flags/svg/France.svg": "2981",
	"./images/flags/svg/French Polynesia.svg": "246a",
	"./images/flags/svg/Gabon.svg": "979e",
	"./images/flags/svg/Galapagos Islands.svg": "b38c",
	"./images/flags/svg/Gambia.svg": "3ed1",
	"./images/flags/svg/Georgia.svg": "ccb1",
	"./images/flags/svg/Germany.svg": "4126",
	"./images/flags/svg/Ghana.svg": "e74b",
	"./images/flags/svg/Gibraltar.svg": "117c",
	"./images/flags/svg/Greece.svg": "0e18",
	"./images/flags/svg/Greenland.svg": "84ff",
	"./images/flags/svg/Grenada.svg": "af55",
	"./images/flags/svg/Guam.svg": "e040",
	"./images/flags/svg/Guatemala.svg": "e11f",
	"./images/flags/svg/Guernsey.svg": "1cf8",
	"./images/flags/svg/Guinea Bissau.svg": "5fb4",
	"./images/flags/svg/Guinea.svg": "498b",
	"./images/flags/svg/Guyana.svg": "1ba5",
	"./images/flags/svg/Haiti.svg": "a753",
	"./images/flags/svg/Hawaii.svg": "023a",
	"./images/flags/svg/Honduras.svg": "f743",
	"./images/flags/svg/Hong Kong.svg": "fa4e",
	"./images/flags/svg/Hungary.svg": "6d7f",
	"./images/flags/svg/Iceland.svg": "05b1",
	"./images/flags/svg/India.svg": "f5b1",
	"./images/flags/svg/Indonesia.svg": "07d9",
	"./images/flags/svg/International.svg": "1b64",
	"./images/flags/svg/Iran.svg": "e236",
	"./images/flags/svg/Iraq.svg": "e777",
	"./images/flags/svg/Ireland.svg": "2a73",
	"./images/flags/svg/Isle of Man.svg": "3a5a",
	"./images/flags/svg/Israel.svg": "c655",
	"./images/flags/svg/Italy.svg": "c39d",
	"./images/flags/svg/Ivory Coast.svg": "b354",
	"./images/flags/svg/Jamaica.svg": "f740",
	"./images/flags/svg/Japan.svg": "6f128",
	"./images/flags/svg/Jersey.svg": "3e66",
	"./images/flags/svg/Jordan.svg": "9477",
	"./images/flags/svg/Kazakhstan.svg": "a3ff",
	"./images/flags/svg/Kenya.svg": "dc63",
	"./images/flags/svg/Kiribati.svg": "6fb0",
	"./images/flags/svg/Kosovo.svg": "aa64",
	"./images/flags/svg/Kuwait.svg": "f056",
	"./images/flags/svg/Kyrgyzstan.svg": "8191",
	"./images/flags/svg/Laos.svg": "b486",
	"./images/flags/svg/Latvia.svg": "43a6",
	"./images/flags/svg/Lebanon.svg": "c0d8",
	"./images/flags/svg/Lesotho.svg": "e04e",
	"./images/flags/svg/Liberia.svg": "68d9",
	"./images/flags/svg/Libya.svg": "cd22",
	"./images/flags/svg/Liechtenstein.svg": "fa09",
	"./images/flags/svg/Lithuania.svg": "38c9",
	"./images/flags/svg/Luxembourg.svg": "514a",
	"./images/flags/svg/Macao.svg": "4428",
	"./images/flags/svg/Macedonia.svg": "2f63",
	"./images/flags/svg/Madagascar.svg": "c229",
	"./images/flags/svg/Madeira.svg": "8962",
	"./images/flags/svg/Malawi.svg": "e13e",
	"./images/flags/svg/Malaysia.svg": "f9d9",
	"./images/flags/svg/Maldives.svg": "904c",
	"./images/flags/svg/Mali.svg": "5013",
	"./images/flags/svg/Malta.svg": "97aa",
	"./images/flags/svg/Marshall Island.svg": "f0eb",
	"./images/flags/svg/Martinique.svg": "2cba",
	"./images/flags/svg/Mauritania.svg": "f1ea",
	"./images/flags/svg/Mauritius.svg": "6d15",
	"./images/flags/svg/Melilla.svg": "4d24",
	"./images/flags/svg/Mexico.svg": "3690",
	"./images/flags/svg/Micronesia.svg": "4bc2",
	"./images/flags/svg/Moldova.svg": "1e03",
	"./images/flags/svg/Monaco.svg": "c03b",
	"./images/flags/svg/Mongolia.svg": "d5fa",
	"./images/flags/svg/Montenegro.svg": "4cbe",
	"./images/flags/svg/Montserrat.svg": "304e",
	"./images/flags/svg/Morocco.svg": "279c",
	"./images/flags/svg/Mozambique.svg": "7ccb",
	"./images/flags/svg/Myanmar.svg": "59c3",
	"./images/flags/svg/Namibia.svg": "c2bb",
	"./images/flags/svg/Nato.svg": "42e0",
	"./images/flags/svg/Nauru.svg": "143e",
	"./images/flags/svg/Nepal.svg": "fa8f",
	"./images/flags/svg/Netherlands.svg": "e7a0",
	"./images/flags/svg/New Zealand.svg": "f1e7",
	"./images/flags/svg/Nicaragua.svg": "52a2",
	"./images/flags/svg/Niger.svg": "701a",
	"./images/flags/svg/Nigeria.svg": "1544",
	"./images/flags/svg/Niue.svg": "838d",
	"./images/flags/svg/Norfolk Island.svg": "4b6a",
	"./images/flags/svg/North Korea.svg": "7839",
	"./images/flags/svg/Northern Cyprus.svg": "4e2f",
	"./images/flags/svg/Northern Ireland.svg": "3e60",
	"./images/flags/svg/Northern Marianas Islands.svg": "9766",
	"./images/flags/svg/Norway.svg": "13b6",
	"./images/flags/svg/Oman.svg": "f06b",
	"./images/flags/svg/Orkney Islands.svg": "a3a7",
	"./images/flags/svg/Ossetia.svg": "b897",
	"./images/flags/svg/Pakistan.svg": "6bf0",
	"./images/flags/svg/Palau.svg": "73d5",
	"./images/flags/svg/Palestine.svg": "ddc6",
	"./images/flags/svg/Panama.svg": "885a",
	"./images/flags/svg/Papua New Guinea.svg": "dbaa",
	"./images/flags/svg/Paraguay.svg": "4356",
	"./images/flags/svg/Peru.svg": "81f2",
	"./images/flags/svg/Philippines.svg": "4720",
	"./images/flags/svg/Pitcairn Islands.svg": "a217",
	"./images/flags/svg/Poland.svg": "3e37",
	"./images/flags/svg/Portugal.svg": "f8c0",
	"./images/flags/svg/Puerto Rico.svg": "f4f1",
	"./images/flags/svg/Qatar.svg": "d930",
	"./images/flags/svg/Rapa Nui.svg": "e60e",
	"./images/flags/svg/Republic of the Congo.svg": "b6bf",
	"./images/flags/svg/Romania.svg": "0697",
	"./images/flags/svg/Russia.svg": "b1ae",
	"./images/flags/svg/Rwanda.svg": "d3cb",
	"./images/flags/svg/Saba Island.svg": "34ec",
	"./images/flags/svg/Sahrawi Arab Democratic Republic.svg": "1855",
	"./images/flags/svg/Saint Kitts and Nevis.svg": "bb8f",
	"./images/flags/svg/Samoa.svg": "7f3c",
	"./images/flags/svg/San Marino.svg": "f70d",
	"./images/flags/svg/Sao Tome and Prince.svg": "38b3",
	"./images/flags/svg/Sardinia.svg": "723d",
	"./images/flags/svg/Saudi Arabia.svg": "d00f",
	"./images/flags/svg/Scotland.svg": "2b98",
	"./images/flags/svg/Senegal.svg": "1792",
	"./images/flags/svg/Serbia.svg": "e890",
	"./images/flags/svg/Seychelles.svg": "321d",
	"./images/flags/svg/Sierra-Leone.svg": "1121",
	"./images/flags/svg/Singapore.svg": "70c0",
	"./images/flags/svg/Sint Eustatius.svg": "0246",
	"./images/flags/svg/Sint Maarten.svg": "3047",
	"./images/flags/svg/Slovakia.svg": "ca60",
	"./images/flags/svg/Slovenia.svg": "cd72",
	"./images/flags/svg/Solomon Islands.svg": "b121",
	"./images/flags/svg/Somalia.svg": "ebc5",
	"./images/flags/svg/Somaliland.svg": "dfe4",
	"./images/flags/svg/South Africa.svg": "a0d6",
	"./images/flags/svg/South Korea.svg": "26ec",
	"./images/flags/svg/South Sudan.svg": "17b8",
	"./images/flags/svg/Spain.svg": "2c1a",
	"./images/flags/svg/Sri Lanka.svg": "db98",
	"./images/flags/svg/St Barts.svg": "8b7f",
	"./images/flags/svg/St Lucia.svg": "d904",
	"./images/flags/svg/St Vincent and the Grenadines.svg": "89e3",
	"./images/flags/svg/Sudan.svg": "f3f7",
	"./images/flags/svg/Suriname.svg": "2173",
	"./images/flags/svg/Sweden.svg": "b40e",
	"./images/flags/svg/Switzerland.svg": "7f3b",
	"./images/flags/svg/Syria.svg": "4326",
	"./images/flags/svg/Taiwan.svg": "951e",
	"./images/flags/svg/Tajikistan.svg": "63ed",
	"./images/flags/svg/Tanzania.svg": "edb8",
	"./images/flags/svg/Thailand.svg": "e525",
	"./images/flags/svg/Tibet.svg": "3eb2",
	"./images/flags/svg/Togo.svg": "7df8",
	"./images/flags/svg/Tokelau.svg": "7c9e",
	"./images/flags/svg/Tonga.svg": "1860",
	"./images/flags/svg/Transnistria.svg": "6515",
	"./images/flags/svg/Trinidad & Tobago.svg": "8a54",
	"./images/flags/svg/Tunisia.svg": "6ae8",
	"./images/flags/svg/Turkey.svg": "8ed1",
	"./images/flags/svg/Turkmenistan.svg": "35ac",
	"./images/flags/svg/Turks and Caicos.svg": "0056",
	"./images/flags/svg/Tuvalu.svg": "4b0c",
	"./images/flags/svg/USA.svg": "e5ae",
	"./images/flags/svg/Uganda.svg": "0536",
	"./images/flags/svg/Ukraine.svg": "d4d6",
	"./images/flags/svg/United Arab Emirates.svg": "738b",
	"./images/flags/svg/United Kingdom.svg": "8390",
	"./images/flags/svg/United Nations.svg": "52bc",
	"./images/flags/svg/Unknown.svg": "43dd",
	"./images/flags/svg/Uruguay.svg": "3834",
	"./images/flags/svg/Uzbekistán.svg": "73cd",
	"./images/flags/svg/Vanuatu.svg": "6026",
	"./images/flags/svg/Vatican City.svg": "c534",
	"./images/flags/svg/Venezuela.svg": "308f",
	"./images/flags/svg/Vietnam.svg": "0d22",
	"./images/flags/svg/Virgin Islands.svg": "74b9",
	"./images/flags/svg/Wales.svg": "4478",
	"./images/flags/svg/Yemen.svg": "757a",
	"./images/flags/svg/Zambia.svg": "0d80",
	"./images/flags/svg/Zimbabwe.svg": "ba6e",
	"./images/lock-26.png": "6c42",
	"./images/menu-26.png": "8a47",
	"./images/password2-26.png": "8237",
	"./images/search-26.png": "5fbc",
	"./images/settings-26.png": "b37a",
	"./images/sports/svg/americanfootball.svg": "46f1",
	"./images/sports/svg/basketball.svg": "818c",
	"./images/sports/svg/boxing.svg": "08dc",
	"./images/sports/svg/cricket.svg": "9d19",
	"./images/sports/svg/darts.svg": "bad1",
	"./images/sports/svg/football.svg": "61b4",
	"./images/sports/svg/gaa.svg": "74f6",
	"./images/sports/svg/golf.svg": "5f81",
	"./images/sports/svg/handball.svg": "5ed6",
	"./images/sports/svg/horseracing.svg": "5cf7",
	"./images/sports/svg/icehockey.svg": "ad35",
	"./images/sports/svg/motorsport.svg": "fcaf8",
	"./images/sports/svg/rugbyleague.svg": "4f0d",
	"./images/sports/svg/rugbyunion.svg": "26e4",
	"./images/sports/svg/snooker.svg": "8738",
	"./images/sports/svg/soccer.svg": "4c0e",
	"./images/sports/svg/specials.svg": "2182",
	"./images/sports/svg/tabletennis.svg": "14ea",
	"./images/sports/svg/tennis.svg": "7f63",
	"./images/statistics.png": "624c",
	"./images/unlock-26.png": "9cf3",
	"./slides/smallwhatwedo - German.html": "e56d",
	"./slides/smallwhatwedo - Ireland old.html": "9053",
	"./slides/smallwhatwedo - Ireland.html": "9e33",
	"./slides/smallwhatwedo - United Kingdom.html": "9a11",
	"./slides/whatisitabout.html": "65e4",
	"./slides/whatwedo - Germany.html": "96d4",
	"./slides/whatwedo - Ireland.html": "b87e",
	"./slides/whatwedo - United Kingdom.html": "6af7",
	"./stylesheets/autocomplete.css": "21e9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1913";